const state= {
    equipCats: [],
    equipmentLoading: {
        category:false,
    },
};

const getters = {
    ListEquipCats : (state) => state.equipCats,
    equipmentLoading : (state) => state.equipmentLoading,
};

const actions = {
    async getEquipmentCategory({commit}, params){
        let id = params.id || 0;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "category",val : true} );
            global.axios.get(`api/master/tree-equiqment-structures/${id}`)
            .then(response => {
                commit( 'setLoading', {key: "category",val : false} );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getServiceCategory({commit}, params){
        let id = params || 0
        return new Promise((resolve, reject) => {
            global.axios(`/api/master/tree-service-categories/${id}`, {
                method: "GET",
                data: {},
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
    /*Equipment Categories*/
    async CreateEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/master/equiqment-structures`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    if(response.data.status == 200) {
                        commit('setListEquipCats', { id: response.data.data.id, data: response.data.data })
                    }
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async UpdateEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/master/equiqment-structures/` + params.id, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async DeleteEquipmentStructure({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`/api/master/equiqment-structures/` + params.id, {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit('StatusController/setequipmentStructure',{ key : 'equipment', value : true }, { root: true });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setLoading (state,params) {
        if(params.key === "category"){
            state.equipmentLoading.category = params.val;
        }
    },
    setListEquipCats (state, data) {
        state.equipCats = data
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
